// Bayiler (süper admin) sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'superadmin.dealers';

export const superAdminDealersGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Bayiler sayfası nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Bayileri oluşturur, şirket açma kotalarını belirler, şirketleri bayilere atar ve bayileri aktif / pasif yaparsınız. Bu sayfayı yalnız süper admin kullanır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Bayiler'),
    filters: t(`${G}.regions.filters`, 'Bayi ara ve toplam'),
    toolbar: t(`${G}.regions.toolbar`, 'Bayi Oluştur'),
    table: t(`${G}.regions.table`, 'Bayi listesi'),
  },
  steps: [
    {
      region: 'filters',
      title: t(`${G}.s1.title`, '1. Bayiyi bulun'),
      text: t(`${G}.s1.text`, '"Bayi ara..." kutusuna bayi adı, e-posta ya da telefon yazın. "Toplam Bayi" arama sonucundaki bayi sayısını gösterir.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s2.title`, '2. Yeni bayi oluşturun'),
      text: t(`${G}.s2.text`, '"Bayi Oluştur" penceresinde Bayi Adı, E-posta ve Şifre (en az 6 karakter) zorunludur; Telefon, Yetkili Adı ve Soyadı isteğe bağlıdır. Kaydedince bayi ile birlikte bayinin giriş kullanıcısı da oluşur; bayi bu e-posta ve şifreyle giriş yapar.'),
      tips: [
        t(`${G}.s2.tip1`, '"Açabileceği Şirket Sayısı (kota)" bayinin kendisinin kaç şirket açabileceğidir. 0 verirseniz bayi hiç şirket açamaz.'),
        t(`${G}.s2.tip2`, 'Bayinin açtığı şirketlerde tüm modüller kapalı gelir; modül iznini siz verirsiniz (Süper Admin Paneli › şirket menüsü › Modüller).'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Listeyi okuyun, bayiyi pasife alın'),
      text: t(`${G}.s3.text`, 'Her satırda bayi, bayi kullanıcısı, telefon, "Şirket / Kota" (bayideki şirket sayısı / kota), kayıt tarihi ve Aktif anahtarı görünür. Kota dolmuşsa sayı kırmızı görünür ve bayi yeni şirket açamaz.'),
      tips: [
        t(`${G}.s3.tip1`, 'Aktif anahtarını kapatmak bayiyi pasifleştirir: bayi kullanıcıları yönetim işlemlerinde erişim engeline takılır. Anahtarı tekrar açarak bayiyi aktifleştirebilirsiniz.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Kotayı değiştirin'),
      text: t(`${G}.s4.text`, 'Satırdaki "Şirketler" düğmesi bayinin penceresini açar. "Şirket Açma Kotası" alanına yeni sayıyı yazıp "Kotayı Kaydet" deyin; yanındaki etiket kullanılan / kota bilgisini gösterir.'),
      tips: [
        t(`${G}.s4.tip1`, 'Kotayı bayideki mevcut şirket sayısının altına da çekebilirsiniz; var olan şirketler etkilenmez, bayi yalnız yeni şirket açamaz.'),
        t(`${G}.s4.tip2`, 'Bayinin yeni şirket açıp açamayacağı hesaplanırken bayiye bağlı tüm şirketler sayılır; elle atadığınız şirketler de bu sayıya girer.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Şirketleri bayiye atayın'),
      text: t(`${G}.s5.text`, 'Aynı pencerede "Şirket ara ve seç..." kutusundan şirketi seçip "Ata" deyin. Elle atama kota sınırına takılmaz. "Atanmış Şirketler" listesindeki zincir düğmesi atamayı kaldırır; şirket merkeze döner.'),
      tips: [
        t(`${G}.s5.tip1`, 'Bir şirket aynı anda yalnız bir bayide olabilir. Başka bayideki bir şirketi seçerseniz ("Şu an: ... (atama taşınır)") ataması bu bayiye taşınır.'),
      ],
    },
  ],
});
